import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Input, Select, Button, message, DatePicker, Upload, Spin } from "antd";
import { getParmUrl, isPdf, tokenConfig } from "@/public/utils";
import _, { get } from "lodash";
import common from "@/public/common";
import styles from "./../index.module.less";
import moment from "moment";
import "moment/locale/zh-cn";
import { UploadOutlined } from "@ant-design/icons";
import {
  queryQualificationDetailApi,
  saveQualificationDetailApi,
} from "./../service";
import { getCookie } from "@/public/utils";
import ImgPreView from "@/compenents/imgPreView";
import "./common.less";
import {
  transformQueryData,
  transformSaveData,
  createHandleChangeInput,
  createHandelSelect,
  createHandleChangeDate,
  createHandleChangeResponsibility,
  createHandleDeleteImage,
  createHandleChangeFileAuthorize,
  createHandleDeleteFile,
  createOnPreview,
  createCheckQualificationsData,
  getShow,
} from "./qualification-util";

var apihost = common.scpUrl;

const { Option } = Select;

const BasicQualification = (props, ref) => {
  var getCurrent = props.getCurrent;
  var disabledStatus = !!getParmUrl("stepaction");

  var _s = useState([]);
  var qualificationData = _s[0];
  var setQualificationData = _s[1];

  var _s2 = useState(false);
  var loading = _s2[0];
  var setLoading = _s2[1];

  var _s3 = useState(false);
  var previewVisible = _s3[0];
  var setPreviewVisible = _s3[1];

  var _s4 = useState([]);
  var preViewImgList = _s4[0];
  var setPreViewImgList = _s4[1];

  useEffect(function () {
    queryQualificationFunc();
  }, []);

  var queryQualificationFunc = async () => {
    if (["null", null, undefined].includes(getCookie("supplier_code"))) {
      return;
    }
    setLoading(true);
    try {
      var res = await queryQualificationDetailApi({
        operator_system: "scs",
        need_query_on_change: true,
        charge_code_list: [],
        now: moment(),
        change_code: "",
        need_match_change: false,
        supplier_code: getCookie("supplier_code") || "",
        need_query_charge_qua: true,
        is_only_config_qua: true, //基础资质查询传 true,合规资质补充时,传false
      });
      setLoading(false);
      if (res.data.code == "0" && get(res, "data.data")) {
        var newData = get(res, "data.data");
        console.log(newData);
        var data = transformQueryData(newData);
        console.log(data);
        setQualificationData(data);
      }
    } catch (err) {
      setLoading(false);
      setQualificationData([]);
    }
  };

  // 公共 handler（从 qualification-util 工厂创建）
  var handleChangeInput = createHandleChangeInput(qualificationData, setQualificationData);
  var handelSelect = createHandelSelect(qualificationData, setQualificationData);
  var handleChangeDate = createHandleChangeDate(qualificationData, setQualificationData);
  var handleChangeResponsibility = createHandleChangeResponsibility(qualificationData, setQualificationData);
  var handleDeleteImage = createHandleDeleteImage(qualificationData, setQualificationData);
  var handleChangeFileAuthorize = createHandleChangeFileAuthorize(qualificationData, setQualificationData);
  var handleDeleteFile = createHandleDeleteFile(qualificationData, setQualificationData);
  var onPreview = createOnPreview(setPreViewImgList, setPreviewVisible);
  var checkQualificationsData = createCheckQualificationsData(qualificationData);

  // 保存 / 提交
  var handleSave = async function (isSubmit) {
    // 提交时需要先校验必填，保存时跳过校验
    if (isSubmit && !checkQualificationsData()) {
      throw new Error("校验未通过");
    }
    setLoading(true);
    try {
      var saveData = transformSaveData(qualificationData);
      var res = await saveQualificationDetailApi({
        supplier_code: getCookie("supplier_code") || "",
        qualification_list: saveData,
        is_submit: isSubmit,
        operator_system: "scs",
        now: moment(),
      });
      setLoading(false);
      if (res.data.code == "0") {
        if (isSubmit) {
          message.success("基础资质提交成功");
          // 提交成功后重新查询状态，由父组件按最新 supplier_status 跳到正确步骤
          if (props.onStatusRefresh) {
            props.onStatusRefresh();
          } else {
            getCurrent(3);
          }
        } else {
          message.success("基础资质保存成功");
          getCurrent(2);
        }
        queryQualificationFunc();
      } else {
        // 业务失败：已弹 message，不再走 catch 兜底，直接 resolve 结束按钮 loading
        message.error(res.data.message || "");
      }
    } catch (err) {
      setLoading(false);
      // 仅在真正的网络/未知异常时弹兜底提示
      message.error("操作失败");
      throw err;
    }
  };

  // 暴露给父组件底部按钮调用，返回 Promise 以支持按钮 loading
  useImperativeHandle(ref, () => ({
    save: () => handleSave(false),
    submit: () => handleSave(true),
  }));

  var renderQualificationData = () => {
    if (!qualificationData || qualificationData.length === 0) return null;
    return qualificationData.map((item, index) => {
      return (
        <div key={index}>
          {item.qua_value
            ? item.qua_value.map((item2, index2) => {
                var timeFields = item2.filter((v) => {
                  return (
                    v.qua_filed_name === "开始时间" ||
                    v.qua_filed_name === "结束时间"
                  );
                });
                var otherFields = item2.filter((v) => {
                  return (
                    v.qua_filed_name !== "开始时间" &&
                    v.qua_filed_name !== "结束时间"
                  );
                });
                return (
                  <div
                    key={index2}
                    style={{
                      border: "1px solid #e8e8e8",
                      borderRadius: "8px",
                      marginBottom: "16px",
                      padding: "16px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        style={{
                          width: "50%",
                          marginBottom: "8px",
                          lineHeight: "32px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            textAlign: "right",
                            width: "100px",
                          }}
                        >
                          {item.is_need === 1 ? (
                            <span style={{ color: "red" }}>*</span>
                          ) : null}
                          资质名称：
                        </span>
                        <span
                          style={{
                            fontWeight: 600,
                            fontSize: "16px",
                          }}
                        >
                          {item.qua_name || "-"}
                        </span>
                        <span style={{ marginLeft: "8px" }}>
                          {getShow(item.qua_name)}
                        </span>
                      </div>
                      {timeFields.length > 0 && (
                        <div
                          style={{
                            width: "50%",
                            marginBottom: "8px",
                            lineHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              textAlign: "right",
                              width: "100px",
                            }}
                          >
                            {timeFields[0].is_need ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                            有效时间：
                          </span>
                          {timeFields.map((m, n) => {
                            var dateValue = null;
                            // is_match_change 为 true 严格取变更后的值（没填就显示空），为 false 取原值
                            var dateField = m.is_match_change
                              ? m.change_after_field_name
                              : m.qua_filed_value;
                            if (dateField) {
                              if (typeof dateField === "string") {
                                dateValue = moment(dateField);
                              } else {
                                dateValue = moment(dateField * 1);
                              }
                            }
                            return (
                              <span key={n}>
                                <DatePicker
                                  format="YYYY-MM-DD"
                                  style={{
                                    width: "144px",
                                    marginRight: "8px",
                                    verticalAlign: "middle",
                                  }}
                                  disabled={disabledStatus}
                                  placeholder={
                                    m.qua_filed_name === "开始时间"
                                      ? "选择开始时间"
                                      : "选择结束时间"
                                  }
                                  onChange={function (e) {
                                    handleChangeDate(
                                      e,
                                      index,
                                      index2,
                                      m.qua_filed_name,
                                    );
                                  }}
                                  value={dateValue}
                                />
                              </span>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    {otherFields.map((item3, index3) => {
                      return (
                        <div
                          key={index3}
                          style={{
                            width: "50%",
                            marginBottom: "8px",
                            display: "inline-block",
                            verticalAlign: "top",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              textAlign: "right",
                              width: "100px",
                            }}
                          >
                            {item3.is_need ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                            {item3.qua_filed_name}：
                          </span>
                          {item3.qua_filed_type === "Text" && (
                            <Input
                              placeholder="请输入"
                              disabled={disabledStatus}
                              value={
                                item3.is_match_change
                                  ? item3.change_after_field_name || ""
                                  : item3.qua_filed_value &&
                                      item3.qua_filed_value !== "null"
                                    ? item3.qua_filed_value
                                    : ""
                              }
                              onChange={function (e) {
                                handleChangeInput(
                                  e,
                                  index,
                                  index2,
                                  item3.qua_filed_name,
                                );
                              }}
                              style={{
                                width: "296px",
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                          )}
                          {item3.qua_filed_type === "Picture" && (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <Upload
                                action={apihost + "supplier-enter/upload-file"}
                                headers={{ ...tokenConfig }}
                                accept="image/jpeg,image/jpg,image/png"
                                disabled={disabledStatus}
                                onChange={function (e) {
                                  handleChangeResponsibility(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                onRemove={function (e) {
                                  handleDeleteFile(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                fileList={item3.imgList || []}
                                onPreview={onPreview}
                              >
                                {disabledStatus ? null : (
                                  <Button disabled={disabledStatus}>
                                    <UploadOutlined /> 上传图片
                                  </Button>
                                )}
                              </Upload>
                              <span
                                style={{
                                  color: "#999",
                                  marginLeft: 8,
                                }}
                              >
                                .jpg,.jpeg,.png
                              </span>
                            </span>
                          )}
                          {item3.qua_filed_type === "File" && (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <Upload
                                action={apihost + "supplier-enter/upload-file"}
                                headers={{ ...tokenConfig }}
                                accept=".pdf"
                                disabled={disabledStatus}
                                onChange={function (e) {
                                  handleChangeFileAuthorize(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                onRemove={function (e) {
                                  handleDeleteFile(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                fileList={item3.fileListNew || []}
                                onPreview={onPreview}
                              >
                                {disabledStatus ? null : (
                                  <Button disabled={disabledStatus}>
                                    <UploadOutlined /> 上传文件
                                  </Button>
                                )}
                              </Upload>
                              <span
                                style={{
                                  color: "#999",
                                  marginLeft: 8,
                                }}
                              >
                                仅支持.pdf
                              </span>
                            </span>
                          )}
                          {item3.qua_filed_type === "Picture&File" && (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <Upload
                                action={apihost + "supplier-enter/upload-file"}
                                headers={{ ...tokenConfig }}
                                accept=".pdf,image/jpeg,image/jpg,image/png"
                                disabled={disabledStatus}
                                onChange={function (e) {
                                  handleChangeFileAuthorize(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                onRemove={function (e) {
                                  handleDeleteFile(
                                    index,
                                    index2,
                                    item3.qua_filed_name,
                                    e,
                                  );
                                }}
                                fileList={item3.fileListNew || []}
                                onPreview={onPreview}
                              >
                                {disabledStatus ? null : (
                                  <Button disabled={disabledStatus}>
                                    <UploadOutlined /> 上传文件
                                  </Button>
                                )}
                              </Upload>
                              <span
                                style={{
                                  color: "#999",
                                  marginLeft: 8,
                                }}
                              >
                                .pdf,.jpg,.jpeg,.png
                              </span>
                            </span>
                          )}
                          {item3.qua_filed_type === "Select" && (
                            <Select
                              showSearch
                              style={{
                                width: 272,
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                              optionFilterProp="children"
                              placeholder="请选择"
                              disabled={disabledStatus}
                              value={
                                item3.is_match_change
                                  ? item3.change_after_field_name
                                  : item3.qua_filed_value
                              }
                              onChange={function (e) {
                                handelSelect(
                                  e,
                                  index,
                                  index2,
                                  item3.qua_filed_name,
                                );
                              }}
                            >
                              <Option key={0} value={0}>
                                不校验
                              </Option>
                              <Option key={1} value={1}>
                                强校验
                              </Option>
                            </Select>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })
            : null}
        </div>
      );
    });
  };

  return (
    <div>
      <div style={{ color: "red" }}>注：请上传带公章图片</div>
      <Spin spinning={loading}>{renderQualificationData()}</Spin>
      <ImgPreView
        previewVisible={previewVisible}
        onClose={function () {
          setPreviewVisible(false);
        }}
        previewIndex={0}
        imgList={preViewImgList}
      />
    </div>
  );
};
export default forwardRef(BasicQualification);



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/supplierinformationentry/basic-qualification.js